import { Moon, Sparkles, CalendarDays } from 'lucide-react';
import { getHijriDate } from '../../lib/hijri';
import { PrayerTimes } from '../../components/culte/PrayerTimes';

/**
 * Onglet « Prières » du hub Spiritualité : date du jour (hégire + grégorien)
 * et horaires des 5 prières. Le Tasbih et la Qibla vivent désormais dans
 * l'onglet « Tasbih & Qibla » du hub.
 */
export default function Spiritualite() {
    const today = new Date();

    // Date hégirienne du jour (calendrier islamique).
    const hijriDate = getHijriDate(today);

    // Date grégorienne formatée en français : "vendredi 20 juin 2026".
    const gregorianDate = new Intl.DateTimeFormat('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(today);

    return (
        <div className="space-y-4 md:space-y-6" data-testid="spiritualite-page">
            {/* Hero gradient avec date hégirienne + grégorienne.
                Compact sur mobile (le contexte « Prières » est déjà donné
                par l'onglet du hub) ; développé sur grand écran. */}
            <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl bg-gradient-to-br from-emerald-600 via-teal-600 to-indigo-700 px-4 py-3 sm:p-8 text-white shadow-lg">
                <div className="absolute -right-8 -top-8 opacity-20 hidden sm:block">
                    <Moon className="h-40 w-40" />
                </div>
                <div className="relative z-10 space-y-2 sm:space-y-3">
                    <div className="hidden sm:flex items-center gap-2 text-white/80">
                        <Sparkles className="h-4 w-4 sm:h-5 sm:w-5" />
                        <span className="text-xs sm:text-sm font-medium uppercase tracking-wide">
                            Espace cultuel
                        </span>
                    </div>
                    <h1 className="hidden sm:block text-2xl sm:text-4xl font-bold">Spiritualité</h1>
                    <p className="hidden sm:block text-white/90 max-w-2xl">
                        Vos repères spirituels au quotidien : horaires de prière, dhikr et
                        direction de la Qibla.
                    </p>

                    {/* Dates */}
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-4 sm:mt-4">
                        {hijriDate && (
                            <div className="inline-flex items-center gap-2 rounded-xl sm:rounded-2xl bg-white/15 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2">
                                <Moon className="h-4 w-4 shrink-0" />
                                <span className="font-semibold text-sm sm:text-base">{hijriDate}</span>
                                <span className="text-white/70 text-xs sm:text-sm">(Hégire)</span>
                            </div>
                        )}
                        <div className="inline-flex items-center gap-2 rounded-xl sm:rounded-2xl bg-white/10 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2">
                            <CalendarDays className="h-4 w-4 shrink-0" />
                            <span className="capitalize text-sm sm:text-base">{gregorianDate}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Horaires des prières */}
            <PrayerTimes />
        </div>
    );
}
